import React from 'react';
import PropTypes from 'prop-types';
import uniqid from 'uniqid';

import {
  getHomepageBlocks,
} from './getHomepageBlocks';

/** Site specific SASS overrides */
import 'Styles/components/_commons.scss'; // there is only footer there now
import 'Styles/components/molecules/_ArticleCard.scss';
import 'Styles/components/organisms/_ArticleGroup.scss';
import 'Styles/components/templates/_Home.scss';

const Home = ({
  layoutData: { page: { associatedContent } },
  config: {
    expertQuote,
    gycConfig,
    regPlateFormConfig,
    newsletterConfig,
  },
}) => {
  const config = {
    expertQuote,
    gycConfig,
    regPlateFormConfig,
    newsletterConfig,
  };
  const components = getHomepageBlocks(associatedContent, config);

  return (
    <>
      <div className="polaris__body">
        <main className="polaris__main" id="main">
          {components && components.length && Array.isArray(components) && components.map(component => (
            <React.Fragment key={uniqid()}>
              {component}
            </React.Fragment>
          ))}
        </main>
      </div>
    </>
  );
};

Home.propTypes = {
  layoutData: PropTypes.shape({
    page: PropTypes.shape({
      associatedContent: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    }).isRequired,
  }).isRequired,
  config: PropTypes.shape({
    expertQuote: PropTypes.shape({}).isRequired,
    gycConfig: PropTypes.shape({}).isRequired,
    regPlateFormConfig: PropTypes.shape({}).isRequired,
    newsletterConfig: PropTypes.shape({}).isRequired,
  }).isRequired,
};

Home.defaultProps = {};

export default Home;
